export default __webpack_public_path__ + "static/media/codeforce.29abb4f0.png";